import { useEffect, useState, useRef } from "react";
import html2pdf from "html2pdf.js";
import React from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import dayjs from "dayjs";
import { format } from "date-fns";
import commonLabels from "../../../common/labels/common_en.json";
import TablePagination from "../../../common/components/TablePagination";
import label from "../../labels/postExaminationProcessObjective_en.json";
import {
  getAdvertisementsList,
  getExamslistByAdvertisementId,
  getSubjectlistByExamId,
  getExaminersAndModeratorReportData,
  getAllApprovalChiefModeratorCriteria,
  getCandidateCountByExamIdSubjectId,
  saveChiefModeratorMarksCriteria,
  getSupervisorlistByExamIdSubjectId,
  getChiefModeratorCandidateListByExamIdSubjectId,
  getChiefModeratorCriteriaStatus,
  getChiefModeratorModeration,
  getModeratorCandidateCountByPercentage,
  getChiefModeratorCandidateCountByPercentage,
} from "../../actions/postExaminationProcessObjectiveActions";

import ApprovalChiefModeratorCriteriaEntity from "../examReport/ApprovalChiefModeratorCriteriaEntity";
import {
  getYearList,
  getAdvertisementlistByYear,
} from "../../../common/actions/commonActions";
import { toastr } from "react-redux-toastr";

let headerField = [
  {
    id: "1",
    steps: "Step 1",
    name: "Criteria",
  },
  {
    id: "2",
    steps: "Step 2",
    name: "Approvals Criteria",
  },
  {
    id: "3",
    steps: "Step 3",
    name: "Get Candidates List",
  },
  {
    id: "4",
    steps: "Step 4",
    name: "Chief Moderation Not Done",
  },
];

const ChiefModeratorCriteria = () => {
  const pdfRef = useRef(null);

  let unapprovalEntityHeader = [
    "No.",
    "Action",
    "Status",
    "Updated On",
    "Exam Name",
    "Subject Name",
    "Entity Type",
    "Approval Type",
    "Approver",
    "Comments By Approver",
    "Action",
  ];

  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  let {
    examList,
    advertisementList,
    subjectList,
    supervisorListById,
    chiefModeratorCriteriaApprovalList,
    chiefModeratorCriteriaApprovalPageNoCounter,
    totalStudentCount,
    marksDifferenceCount,
    chiefModeratorCandidateList,
    chiefModeratorCriteriaStatus,
    getModerationData,
    chiefModeratorPercentageCount,
  } = useSelector((state) => state.postExamProcessObjectReducer, shallowEqual);

  let { yearList, allYearList } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let tableCounterMarkCriteria =
    chiefModeratorCriteriaApprovalPageNoCounter + 1;
  let rowPerPage = 10;

  const [selectedAdvertNo, setSelectedAdvertNo] = useState("");
  const [selectedExam, setSelectedExam] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedSupervisor, setSelectedSupervisor] = useState(1);
  const [supervisor, setSupervisor] = useState("");
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [marks, setMarks] = useState("");
  const [marksDifference, setMarksDifference] = useState([]);
  const session = JSON.parse(sessionStorage.getItem("session"));
  const [editedValues, setEditedValues] = useState({});
  const [percentage, setPercentage] = useState("");
  const [percentageValue, setPercentageValue] = useState([]);
  const [uniqueValues, setUniqueValues] = useState([]);

  const [stepName, setName] = useState("1");
  let [selectedApprovalEntity, setSelectedApprovalEntity] = useState("");
  let [
    selectedChiefModeratorCriteriaApprovalEntity,
    setSelectedChiefModeratorCriteriaApprovalEntity,
  ] = useState("");
  let [approvalEntityModal, setApprovalEntityModal] = useState(false);
  let [
    chiefModeratorCriteriaApprovalEntityModal,
    setChiefModeratorCriteriaApprovalEntityModal,
  ] = useState(false);
  let [listCurrentPage, setListCurrentPage] = useState(0);
  let [listMarkCriteriaCurrentPage, setListMarkCriteriaCurrentPage] =
    useState(0);
  const date = new Date(); // Your date object here
  const formattedDate = format(date, "MM/dd/yyyy");

  const dispatch = useDispatch();

  // const formData = {
  //   markDifference: marks,
  //   totalSelectedCandidateMarks: marksDifference.totalSelectedCount,
  // };

  const formData = {
    markDifference: marks,
    totalSelectedCandidateMarksByMarkDiff:
      marksDifference?.totalSelectedCount || 0,

    percentage: percentage,

    totalSelectedCandidateMarksByPercentage:
      percentageValue?.totalSelectedCount || 0,
  };

  const formPercentageData = {
    percentage: percentage,
    barcodeNumbers: marksDifference?.barcodeNumberList || [],
  };
  const onCalculatePercentage = () => {
    dispatch(
      getChiefModeratorCandidateCountByPercentage(
        selectedExam,
        selectedSubject,
        formPercentageData
      )
    );
  };



  useEffect(() => {
    // Reset state variables when stepName changes
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubject("");
    setSupervisor("");
    setReloadItem(true);
    setSaveButtonFlag(true);
  }, [stepName]);

  useEffect(() => {
    dispatch(getYearList());
    if (stepName === "2") {
      dispatch(getAllApprovalChiefModeratorCriteria(0, rowPerPage));
    }

    // setReloadItem(!reloadItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (stepName === "2") {
      dispatch(
        getAllApprovalChiefModeratorCriteria(
          listMarkCriteriaCurrentPage,
          rowPerPage
        )
      );
    }
  }, [stepName, listMarkCriteriaCurrentPage, rowPerPage, dispatch]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    onCancelButton();
  }, [stepName]);

  useEffect(() => {
    if (marksDifferenceCount) {
      setMarksDifference(marksDifferenceCount);
    }
  }, [marksDifferenceCount]);

  useEffect(() => {
    if (chiefModeratorPercentageCount) {
      setPercentageValue(chiefModeratorPercentageCount);
    }
  }, [chiefModeratorPercentageCount]);

  useEffect(() => {
    if (percentageValue?.barcodeNumberList || marksDifference?.barcodeNumberList) {
      const values = [
        ...new Set([
          ...(marksDifference?.barcodeNumberList || []),
          ...(percentageValue?.barcodeNumberList || []),
        ]),
      ];

      setUniqueValues(values);
    }
  }, [marksDifference, percentageValue]);

  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvertNo(selectedValue);
    examList.length = 0;
    subjectList.length = 0;
    supervisorListById.length = 0;
    setSelectedExam("");
    setSelectedSubject("");
    setSaveButtonFlag(true);

    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onExamChange = (ele) => {
    let selectedValue = ele;
    subjectList.length = 0;
    setSelectedExam(selectedValue);
    setSelectedSubject("");
    setSaveButtonFlag(true);
    selectedValue && dispatch(getSubjectlistByExamId(selectedValue));
    setReloadItem(!reloadItem);
  };

  const onSubjectChange = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);
    dispatch(getChiefModeratorCriteriaStatus(selectedExam, selectedValue));
    // setSaveButtonFlag(false);
    // selectedValue && dispatch(getSupervisorlistByExamIdSubjectId(selectedExam, selectedValue));
    //onSubmit(selectedValue);
    if (supervisorListById) {
      supervisorListById.length = 0;
    }
    setReloadItem(!reloadItem);
    setEditedValues({});
  };

  const onSelectYear = (ele) => {
    if (ele == "") {
      onCancelButton();
    } else {
      let selectedValue = ele;
      setSelectedYear(selectedValue);
      selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
      if (allYearList) {
        allYearList.length = 0;
      }
      if (examList) {
        examList.length = 0;
      }
      if (subjectList) {
        subjectList.length = 0;
      }
      setSaveButtonFlag(true);

      setReloadItem(!reloadItem);
    }
  };
  const onMarksChange = (ele) => {
    let selectedValue = ele;
    setMarks(selectedValue);
  };

  const onCancelButton = () => {
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubject("");
    setSupervisor("");
    setMarks("");
    setSelectedYear("");
    setMarksDifference([]);
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
    allYearList.length = 0;
    examList.length = 0;
    subjectList.length = 0;
    setPercentage("");
    setPercentageValue([]);
    setUniqueValues([]);
  };

  const onChangeSubject = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);
    selectedValue !== "" &&
      dispatch(
        getChiefModeratorCandidateListByExamIdSubjectId(
          selectedExam,
          selectedValue,
          downloadCSV,
          onCancelButton
        )
      );
    setReloadItem(!reloadItem);
  };

  const onSubmit = () => {
    // onCancelButton();
    setSelectedAdvertNo("");
    setSelectedExam("");
    setSelectedSubject("");
    setSupervisor("");
    setMarks("");
    setSelectedYear("");
    setMarksDifference([]);
    setSaveButtonFlag(true);
    setReloadItem(!reloadItem);
    examList.length = 0;
    subjectList.length = 0;
    supervisorListById.length = 0;
    dispatch(
      saveChiefModeratorMarksCriteria(
        selectedExam,
        selectedSubject,
        formData,
        chiefModeratorCriteriaStatus
      )
    );
    setReloadItem(!reloadItem);
    if (allYearList) {
      allYearList.length = 0;
    }
    if (examList) {
      examList.length = 0;
    }
    if (subjectList) {
      subjectList.length = 0;
    }
    if (supervisorListById) {
      supervisorListById.length = 0;
    }
    onCancelButton();
  };

  const handleMarksCriteriaApproval = (ele) => {
    setSelectedChiefModeratorCriteriaApprovalEntity(ele);
    setChiefModeratorCriteriaApprovalEntityModal(true);
  };
  const onCalculate = () => {
    if (marks == "") {
      toastr.warning("Enter Marks Difference");
    } else {
      dispatch(
        getCandidateCountByExamIdSubjectId(selectedExam, selectedSubject, marks)
      );
      setSaveButtonFlag(false);
    }
  };

  function downloadCSV(resData) {
    const data = resData.map((item) => ({
      barcodeNo: item.barcodeNo,
      marks: item.marks,
    }));

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [
        ["barcodeNo", "chiefModeratorMarks"],
        ...data.map((item) => [item.barcodeNo, item.marks]),
      ]
        .map((e) => e.join(","))
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "ChiefModeratorBarcodeAndMarks.csv");
    document.body.appendChild(link);
    link.click();
  }

  const onChangeSub = (ele) => {
    let selectedValue = ele;
    setSelectedSubject(selectedValue);
    selectedValue &&
      dispatch(getChiefModeratorModeration(selectedExam, selectedValue));
    setSaveButtonFlag(false);
    setReloadItem(!reloadItem);
  };

  const genPdf = () => {
    let headerDiv =
      '<div class="row d-flex flex-column align-items-center"><h5>' +
      commonLabels.MPSC +
      "</h5><h5>" +
      getModerationData.examName +
      "</h5><h5>" +
      label.MODERATIONNECESSARYBUTNOTDONE +
      "</h5><h5>" +
      getModerationData.subjectName +
      "</h5></div>";
    const htmlContent = document.createElement("div");
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;

    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: "ChiefModeratorModeration.pdf",
      image: { type: "jpeg", quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: {
        unit: "in",
        format: "a4",
        orientation: "portrait",
        compressPDF: true,
      },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get("pdf")
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth =
            (pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            })
            .split("/")
            .join("/");
          const dateWidth =
            (pdf.getStringUnitWidth(formattedDate) *
              pdf.internal.getFontSize()) /
            pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY);

          const ad = getModerationData.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`ChiefModeratorModeration_${selectedExam}.pdf`);
      });
  };

  return (
    <div className="commonContentArea">
      <h5 className="labelMargin">{label.chiefModeratorCriteria}</h5>
      <div
        className="tab-content border border-light myTabContent"
        id="myTabContentContainer"
      >
        <ul className="nav nav-tabs" id="myTab" role="tablist">
          {headerField &&
            headerField.map((ele, index) => (
              <li className="nav-item" key={ele.id}>
                <a
                  href="#"
                  className={
                    stepName === ele.id
                      ? "nav-link active"
                      : "nav-link bg-profile-tabs"
                  }
                  value="home"
                  id="home-tab"
                  onClick={() => setName(ele.id)}
                  data-toggle="tab"
                  role="tab"
                  aria-controls="home"
                  aria-selected="false"
                >
                  <span>{ele.name}</span>
                </a>
              </li>
            ))}
        </ul>
        <div className="tab-content border border-light" id="myTabContent">
          <div
            className={
              stepName === "1"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group ">
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear2"
                            value={selectedYear}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear2.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedAdvertiseNo2"
                            value={selectedAdvertNo}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {allYearList &&
                              allYearList.length > 0 &&
                              allYearList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo2.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam"
                            value={selectedExam}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectSubject}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSubject"
                            value={selectedSubject}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSubjectChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {subjectList &&
                              subjectList.length > 0 &&
                              subjectList
                                // .filter(
                                //   (element) =>
                                //     element.isDeleted == false &&
                                //     element.isActive === true
                                // )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}({element.type?.toUpperCase()})
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedSubject.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                      </div>
                      {selectedSubject && selectedSubject > 0 && (
                        <>
                          <div className="row">
                            <div className="form-group col-md-12">
                              <table className="table table-bordered text-center">
                                <thead className="thead-light">
                                  <tr>
                                    <th scope="col">Mark Difference</th>
                                    <th scope="col">Selected Candidates</th>
                                    <th scope="col">Remaining Candidates</th>
                                    <th scope="col">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <td>
                                      <input
                                        type="text"
                                        pattern="^([1-9]|[1-9][0-9]|100)$"
                                        name="markDiffrence"
                                        className="form-control"
                                        onChange={(e) => {
                                          onMarksChange(e.target.value);
                                        }}
                                        onKeyPress={(e) => {
                                          const input = e.key.toUpperCase();
                                          const allowedChars = [
                                            "0",
                                            "1",
                                            "2",
                                            "3",
                                            "4",
                                            "5",
                                            "6",
                                            "7",
                                            "8",
                                            "9",
                                          ];

                                          if (
                                            !allowedChars.includes(input) ||
                                            e.target.value.length >= 3
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                      {_.get("markDiffrence.type", errors) ===
                                        "required" && (
                                          <p className="errorText float-left">
                                            {commonLabels.MANDATORY_FIELD_MESSAGE}
                                          </p>
                                        )}
                                    </td>
                                    <td>
                                      {marksDifference.totalSelectedCount}
                                    </td>
                                    <td>
                                      {marksDifference.remainingCandidateCount}
                                    </td>
                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={() => onCalculate()}
                                      >
                                        Apply
                                      </button>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <table className="table table-bordered text-center">
                                <thead className="thead-light">
                                  <tr>
                                    <th scope="col">Percentage</th>
                                    <th scope="col">Selected Candidates</th>
                                    <th scope="col">Remaining Candidates</th>
                                    <th scope="col">Action</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  <tr>
                                    <td>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={percentage}
                                        maxLength={5}
                                        onChange={(e) => {
                                          const input = e.target.value;

                                          if (+input === +input) {
                                            if (parseFloat(input) <= 100) {
                                              setPercentage(input);
                                            }
                                          }
                                        }}
                                      />
                                    </td>

                                    <td>
                                      {percentageValue?.totalSelectedCount}
                                    </td>

                                    <td>
                                      {percentageValue?.remainingCandidateCount}
                                    </td>

                                    <td>
                                      <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        onClick={() => onCalculatePercentage()}
                                      >
                                        Apply
                                      </button>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td>
                                      <strong>Total Candidates:</strong>{" "}
                                      {marksDifference?.totalCandidateCount || 0}
                                    </td>

                                    <td>
                                      <strong>Total Remaining Candidate:</strong>{" "}
                                      {percentageValue?.remainingCandidateCount !== undefined
                                        ? percentageValue.remainingCandidateCount
                                        : marksDifference?.remainingCandidateCount || 0}
                                    </td>

                                    <td>
                                      <strong>Total Selected Candidate:</strong>{" "}
                                      {(marksDifference?.totalSelectedCount || 0) +
                                        (percentageValue?.totalSelectedCount || 0)}
                                    </td>

                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                              <strong>Candidates Barcode</strong>
                              <br />
                              <ul className="rollList table-font-12">
                                {uniqueValues.map((barcodeNo, index) => (
                                  <li key={index}>{barcodeNo}</li>
                                ))}
                              </ul>
                            </div>
                          </div>
                        </>
                      )}
                      <div className="row">
                        <div className="form-group col-md-6">
                          <button
                            type="reset"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>
                          <button
                            type="button"
                            className="btn btn-primary mr-2"
                            // onClick={handleSubmit((e) => {
                            //   onSubmit(e);
                            // })}
                            onClick={(e) => {
                              onSubmit(e);
                            }}
                            disabled={saveButtonFlag}
                          // onClick={() => onSaveData()}
                          >
                            {chiefModeratorCriteriaStatus
                              ? commonLabels.BUTTON_UPDATE
                              : commonLabels.BUTTON_SAVE}
                          </button>
                          {/* <button
                            type="button"
                            className="btn btn-primary"
                            disabled={saveButtonFlag}
                          // onClick={() => patchData()}
                          >
                            Update
                          </button> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div
            className={
              stepName === "2"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            {chiefModeratorCriteriaApprovalList &&
              chiefModeratorCriteriaApprovalList.entityApprovalDtoList &&
              chiefModeratorCriteriaApprovalList.entityApprovalDtoList.length >
              0 ? (
              <>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      {unapprovalEntityHeader &&
                        unapprovalEntityHeader.map((itm, ind) => (
                          <th
                            key={ind}
                            className={`${itm === "No." || itm === "Action"
                              ? "text-center"
                              : ""
                              }`}
                          >
                            {itm}
                          </th>
                        ))}
                    </tr>
                  </thead>
                  <tbody>

                    {chiefModeratorCriteriaApprovalList &&
                      chiefModeratorCriteriaApprovalList.entityApprovalDtoList &&
                      chiefModeratorCriteriaApprovalList.entityApprovalDtoList
                        .length > 0 &&
                      chiefModeratorCriteriaApprovalList.entityApprovalDtoList.map(
                        (ele, index) => {
                          return (
                            <tr key={index}>
                              <td className="w-5 text-center">
                                {tableCounterMarkCriteria++}
                              </td>
                              <td className=" word-break">
                                {ele.entityApprovalAction.actionLabel}
                              </td>
                              <td className=" width-5">
                                {ele.entityApprovalAction.level == 1
                                  ? label.APPROVAL_LEVEL_1_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 2
                                  ? label.APPROVAL_LEVEL_2_PENDING
                                  : ""}
                                {ele.entityApprovalAction.level == 3
                                  ? label.APPROVAL_LEVEL_3_PENDING
                                  : ""}
                              </td>
                              <td className=" word-break width-10">
                                {ele.entityApprovalAction.updatedAt
                                  ? dayjs(
                                    ele.entityApprovalAction.updatedAt
                                  ).format("DD/MM/YYYY h:mm A")
                                  : ""}
                              </td>
                              {/* <td className='text-centerw-10 word-break  text-center width-20'>
                                                  {ele.entityApprovalAction.entityApprovalDto.detail && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam.name} <br /> {ele.entityApprovalAction.entityApprovalDto.detail && ele.entityApprovalAction.entityApprovalDto.detail.exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam && ele.entityApprovalAction.entityApprovalDto.detail.marks[0].exam.name}
                                              </td> */}
                              <td className="w-10 word-break width-20">
                                {(() => {
                                  const parsedDetail =
                                    typeof ele.entityApprovalAction.entityApprovalDto.detail === "string"
                                      ? JSON.parse(ele.entityApprovalAction.entityApprovalDto.detail)
                                      : ele.entityApprovalAction.entityApprovalDto.detail;

                                  return parsedDetail?.examName || "-";
                                })()}
                              </td>

                              <td className="w-10 word-break width-15">
                                {(() => {
                                  const parsedDetail =
                                    typeof ele.entityApprovalAction.entityApprovalDto.detail === "string"
                                      ? JSON.parse(ele.entityApprovalAction.entityApprovalDto.detail)
                                      : ele.entityApprovalAction.entityApprovalDto.detail;

                                  return parsedDetail?.subjectName || "-";
                                })()}
                              </td>
                              <td className=" word-break ">
                                {ele.entityApprovalAction.entityApprovalDto.entityMaster.name.replace(
                                  "_",
                                  " "
                                )}
                              </td>
                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.entityApprovalDto
                                    .approvalTypeLabel
                                }
                              </td>
                              <td className=" word-break">
                                {
                                  ele.entityApprovalAction.actionByUser
                                    .firstName
                                }{" "}
                                {ele.entityApprovalAction.actionByUser.lastName}
                              </td>
                              <td className=" word-break">
                                {ele.entityApprovalAction.comments}
                              </td>
                              <td className="text-center word-break width-20">
                                {(session.roleName == "superadmin" ||
                                  session.roleName == "desk officer") && (
                                    <button
                                      type="button"
                                      className="mx-auto btn btn-outline-primary btn-sm custom-button"
                                      onClick={() => {
                                        handleMarksCriteriaApproval(ele);
                                      }}
                                    >
                                      {label.REVIEW}
                                    </button>
                                  )}
                              </td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
                <TablePagination
                  paginationFor="un_chief_moderator_criteria_list"
                  rowPerPage={rowPerPage}
                  setListCurrentPage={setListMarkCriteriaCurrentPage}
                  totalCount={
                    chiefModeratorCriteriaApprovalList.totalNoOfRecords
                  }
                />
              </>
            ) : (
              <div className="text-center width-lg-ap">
                <font className="text-danger">
                  {commonLabels.NO_DATA_FOUND}
                </font>
              </div>
            )}
          </div>
          <div
            className={
              stepName === "3"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear1"
                            value={selectedYear}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear1.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            value={selectedAdvertNo}
                            name="selectedAdvertiseNo1"
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {allYearList &&
                              allYearList.length > 0 &&
                              allYearList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo1.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam3"
                            // value={selectedExam}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam3.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectSubject}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSubject3"
                            // value={selectedSubject}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onChangeSubject(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {subjectList &&
                              subjectList.length > 0 &&
                              subjectList
                                // .filter(
                                //   (element) =>
                                //     element.isDeleted == false &&
                                //     element.isActive === true
                                // )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}({element.type?.toUpperCase()})
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedSubject3.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                      </div>
                      <div className="row">
                        <div className="form-group col-md-6">
                          <button
                            type="reset"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div
            className={
              stepName === "4"
                ? "tab-pane fade show active"
                : "tab-pane fade styled-tab"
            }
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="row dashboardCards">
              <div className="col-md-12">
                <form name="importForm" encType="multipart/form-data">
                  <div className="form-group">
                    <div>
                      <div className="row">
                        <div className="form-group col-md-2">
                          <label className="float-left">
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedYear4"
                            value={selectedYear}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onSelectYear(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {yearList &&
                              yearList.length > 0 &&
                              yearList.map((element, index) => (
                                <option>{element}</option>
                                // <option key={index} value={element.id}>
                                //   {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                // </option>
                              ))}
                          </select>
                          {_.get("selectedYear4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                        <div className="form-group col-md-4">
                          <label className="float-left">
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedAdvertiseNo4"
                            value={selectedAdvertNo}
                            // ref={register({ required: true })}
                            onChange={(e) => {
                              onAdvertisementChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {allYearList &&
                              allYearList.length > 0 &&
                              allYearList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {`${element.advertisementNo}/${element.year} - ${element.name}`}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedAdvertiseNo4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedExam4"
                            // value={selectedExam}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onExamChange(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {examList &&
                              examList.length > 0 &&
                              examList
                                .filter(
                                  (element) =>
                                    element.isDeleted == false &&
                                    element.isActive === true
                                )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedExam4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>

                        <div className="form-group col-md-3">
                          <label className="float-left">
                            {label.SelectSubject}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            name="selectedSubject4"
                            // value={selectedSubject}
                            ref={register({ required: true })}
                            onChange={(e) => {
                              onChangeSub(e.target.value);
                            }}
                          >
                            <option key={0} value="">
                              {commonLabels.COMBO_SELECT}
                            </option>
                            {subjectList &&
                              subjectList.length > 0 &&
                              subjectList
                                // .filter(
                                //   (element) =>
                                //     element.isDeleted == false &&
                                //     element.isActive === true
                                // )
                                .map((element, index) => (
                                  <option key={index} value={element.id}>
                                    {element.name}({element.type?.toUpperCase()})
                                  </option>
                                ))}
                          </select>
                          {_.get("selectedSubject4.type", errors) ===
                            "required" && (
                              <p className="errorText float-left">
                                {commonLabels.MANDATORY_FIELD_MESSAGE}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="row">
                        <div className="form-group col-md-6">
                          <button
                            type="reset"
                            className="btn btn-secondary mr-2"
                            onClick={() => onCancelButton()}
                          >
                            {commonLabels.BUTTON_CANCEL}
                          </button>

                          {(session.roleName == "superadmin" ||
                            session.roleName == "secretary") && (
                              <button
                                type="button"
                                className="btn btn-primary mr-2"
                                disabled={saveButtonFlag || !getModerationData.chiefModerationNotDoneReportDtos}
                                onClick={() => {
                                  genPdf();
                                }}
                              >
                                {commonLabels.BUTTON_PRINT}
                              </button>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            {selectedSubject &&
              getModerationData &&
              getModerationData.chiefModerationNotDoneReportDtos &&
              getModerationData.chiefModerationNotDoneReportDtos.length > 0 && (
                <div ref={pdfRef}>
                  <table className="table text-center">
                    <thead>
                      <tr className="text-center">
                        <th
                          colspan="5"
                          className="customTableStyle"
                        >
                          <span>Examiner Marks</span>
                          <br />
                          <span>Moderator Marks</span>
                        </th>
                        <th
                          colspan="5"
                          className="customTableStyle"
                        >
                          <span>Examiner Marks</span>
                          <br />
                          <span>Moderator Marks</span>
                        </th>
                      </tr>
                      <tr>
                        <th
                          className="customTableStyle"
                        >
                          <span>Sr. No.</span>
                          <br />
                          <span>CODE</span>
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q1
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q2
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q3
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Total
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          <span>Sr. No.</span>
                          <br />
                          <span>CODE</span>
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q1
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q2
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Q3
                        </th>
                        <th
                          className="customTableStyle"
                        >
                          Total
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {getModerationData.chiefModerationNotDoneReportDtos.map(
                        (item, index) => (
                          <React.Fragment key={index}>
                            <tr>
                              <td>
                                <span>{index + 1}</span>
                                <br />
                                <span>
                                  <strong>{item.code}</strong>
                                </span>
                              </td>
                              <td>
                                <span>{item.examinerMarks}</span><br />
                                <span>{item.moderatorMarks}</span>
                              </td>
                              <td>-</td>
                              <td>-</td>
                              {/* <td>{item.moderatorMarks || "-"}</td>
                              <td>{item.chiefModeratorMarks || "-"}</td> */}
                              <td>{item.total}</td>
                            </tr>
                          </React.Fragment>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            <br />
            <br />
          </div>

          {chiefModeratorCriteriaApprovalEntityModal && (
            <ApprovalChiefModeratorCriteriaEntity
              showModal={chiefModeratorCriteriaApprovalEntityModal}
              setShowModal={setChiefModeratorCriteriaApprovalEntityModal}
              setSelectedApprovalEntity={
                selectedChiefModeratorCriteriaApprovalEntity
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ChiefModeratorCriteria;
